import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import {
    GetDetailsFailurePayload,
    GetDetailsSuccessPayload,
    SetDescriptionLoadedPayload,
} from 'store/details/actions.types';
import {
    GET_DETAILS,
    GET_DETAILS_FAILURE,
    GET_DETAILS_SUCCESS,
    SET_DESCRIPTION_LOADED,
    SET_DETAILS_EPISODE,
    SET_DETAILS_EPISODE_CAST_AND_CREW,
    SET_UNLOCKED_PAGE,
} from 'store/details/constants';
import { CastCrewPerson, RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';
import { AsyncActionMetaOptions } from 'store/types.ts';

import { VodEditorial } from 'services/data-manager/types';

export function getDetails(
    payload: Omit<RouteNavigationParams[SCREEN.DETAILS], 'templateId'> & {
        templateId: string;
        silently?: boolean;
    },
    meta: AsyncActionMetaOptions = {},
) {
    return {
        type: GET_DETAILS,
        payload,
        meta,
    };
}

export function getDetailsSuccess(payload: GetDetailsSuccessPayload) {
    return {
        type: GET_DETAILS_SUCCESS,
        payload,
    };
}

export function getDetailsFailure(payload: GetDetailsFailurePayload) {
    return {
        type: GET_DETAILS_FAILURE,
        payload,
    };
}

export function setDescriptionLoaded(payload: SetDescriptionLoadedPayload) {
    return {
        type: SET_DESCRIPTION_LOADED,
        payload,
    };
}

export function setUnlockId(payload: string | undefined) {
    return {
        type: SET_UNLOCKED_PAGE,
        payload,
    };
}

export function setDetailsEpisode(
    templateId: string,
    episode: RBProgram | VodEditorial | RecordingItem,
) {
    return {
        type: SET_DETAILS_EPISODE,
        payload: { templateId, episode },
    };
}

export function setDetailsEpisodeCastAndCrew(
    templateId: string,
    castAndCrew: CastCrewPerson[],
) {
    return {
        type: SET_DETAILS_EPISODE_CAST_AND_CREW,
        payload: { templateId, castAndCrew },
    };
}
